import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import RecordHistoryTable from "./RecordHistoryTable";
import { API } from "../../utils/http";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
export default function RecordHistory() {
	const [applications, setApplications] = useState([]);
	useEffect(() => {
		console.log("getting applications");
		API.get("applications", {})
			.then((r) => {
				console.log(r);
				setApplications(r.data.payload.applicant.personalInformation);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);
	const navigate = useNavigate();
	const goToApply = () => {
		navigate("/");
	};
	return (
		<Box>
			{applications.length == 0 ? (
				<Box textAlign={"center"} padding={2} style={{ backgroundColor: "#f5f7fb" }}>
					<InfoIcon color="info" sx={{ fontSize: 50 }} />
					<Typography variant="h4" gutterBottom>
						You currently have no applications.
					</Typography>
					{/* <Typography>You can apply now by clicking the </Typography> */}
					<Button variant="outlined" style={{ textTransform: "capitalize", marginTop: 16 }} onClick={goToApply}>
						Apply Now!
					</Button>
				</Box>
			) : (
				<RecordHistoryTable rows={applications} />
			)}
		</Box>
	);
}
